module.exports = __webpack_public_path__ + "static/media/logo.fd9a7b0c.svg";